import axios from 'axios'

export const updateMatriculas = async (idProject, version) => {
  try {
    await axios.patch(`/api/v1/links/${idProject}/${version}`)
  } catch (e) {
    throw new Error(e)
  }
}
